// 机载 MQTT 保留原始状态码；未知码和旧版固件发来的文字直接显示原值。
const flightModes = {
  0: '自稳',
  2: '定高',
  3: '自动',
  4: '指点',
  5: '定点',
  6: '返航',
  9: '降落',
  16: '定点'
}

const gpsFixTypes = {
  0: 'No Fix',
  1: 'Bad Fix',
  2: '2D Fix',
  3: '3D Fix',
  4: 'DGPS',
  5: 'Float',
  6: 'RTK Fixed'
}

export function getFlightModeLabel (value) {
  const raw = String(value ?? '').trim()
  return Object.prototype.hasOwnProperty.call(flightModes, raw) ? flightModes[raw] : raw
}

export function getGpsFixLabel (value) {
  const raw = String(value ?? '').trim()
  return Object.prototype.hasOwnProperty.call(gpsFixTypes, raw) ? gpsFixTypes[raw] : raw
}

export function hasValidGpsFix (value) {
  const raw = String(value ?? '').trim().toLowerCase()
  return ['2', '3', '4', '5', '6', '2d fix', '3d fix', 'dgps', 'float', 'rtk fixed'].includes(raw)
}

export function isGuidedFlightMode (value) {
  return /^(4|guided|指点)$/i.test(String(value ?? '').trim())
}
